package com.macrofocus.eflux.lod

import com.macrofocus.dom.Definition
import com.macrofocus.dom.toElement
import com.macrofocus.eflux.network.physical.Branch
import com.macrofocus.eflux.ui.ChordTemplate
import com.macrofocus.eflux.ui.PaletteType
import com.macrofocus.eflux.ui.svg.SVGPathBuilder
import org.mkui.geom.Arc2D
import org.mkui.geom.GeneralPath
import org.mkui.geom.PathIterator
import org.molap.dataframe.DataFrame
import org.molap.dataframe.rowmajor.RowMajorDataFrame
import org.w3c.dom.asList
import web.svg.SVGElement
import web.svg.SVGGraphicsElement

fun createChordDiagram(dataFrame: DataFrame<Branch, RowMajorDataFrame.Column<Branch, Any?>, Any?>?,
                       originalShape: SVGGraphicsElement,
                       lodParent: SVGElement,
                       paletteType: PaletteType
                       ) {

    if(dataFrame != null) {
        val lod = NodeLOD(originalShape, dataFrame)
        val originalBBox = lod.originalBBox
        val centerX = lod.centerX
        val centerY = lod.centerY
        val screenInnerRadius = lod.screenInnerRadius
        val screenOuterRadius = lod.screenOuterRadius

        val template = lod.template

        val definition: Definition = com.macrofocus.dom.svg(
            null,
            null,
            originalBBox.x,
            originalBBox.y,
            originalBBox.width,
            originalBBox.height
        ) {
            if (template == ChordTemplate.Circle) {
                "circle"(
                    "cx" to centerX,
                    "cy" to centerY,
                    "r" to (originalBBox.width * 0.5),
                    "fill" to if (paletteType == PaletteType.dark) "black" else "white"
                )
            }

            val model = lod.chordModel
            for (node in model.nodes) {
                val chord = model.getArc(node)

                if (chord != null) {
                    // Draw a dot to represent the center of a node
                    val p = lod.computeOuterPoint((chord.startAngle + (chord.extent / 2)))
                    "circle"(
                        "cx" to p.x,
                        "cy" to p.y,
                        "r" to 0.15,
                        "fill" to if (lod.nodesWithExternalConnections.contains(node)) "rgba(255, 0, 0, 0.5)" else "rgba(0, 255, 0, 0.5)"
                    )

                    // Draw the sector
                    when (template) {
                        ChordTemplate.Circle -> {
                            val path = GeneralPath()
                            val outerArc: PathIterator = lod.sectorOfNode(
                                template,
                                centerX,
                                centerY,
                                screenOuterRadius,
                                chord.startAngle,
                                chord.extent
                            )
                            val innerArc: Arc2D = Arc2D.Double.getArcByCenter(
                                centerX,
                                centerY,
                                screenInnerRadius,
                                90 - (chord.startAngle + chord.extent),
                                chord.extent,
                                Arc2D.OPEN
                            )
                            path.append(outerArc, false)
                            path.append(innerArc.getPathIterator(), true)
                            path.closePath()

                            val d = SVGPathBuilder(path.getPathIterator()).toString()

                            "path"(
                                "d" to d,
                                "fill" to "rgba(0, 0, 127, 0.5)",
                                "stroke" to "rgba(0, 0, 255, 0.5)",
                                "stroke-width" to 0.01
                            )
                        }
                        else -> {}
                    }
                }
            }

            for (from in model.nodes) {
                for (link in model.getLinks(from)) {
                    val to = model.getTo(link)

                    val shape = lod.getShape(from, to)
                    if (shape != null) {
                        val p = SVGPathBuilder(shape.getPathIterator()).toString()

                        "path"(
                            "d" to p,
                            "fill" to if (lod.nodesWithExternalConnections.contains(link.from) || lod.nodesWithExternalConnections.contains(
                                    link.to
                                )
                            ) "rgba(255, 0, 0, 0.5)" else "rgba(0, 255, 0, 0.5)",
                            "stroke" to "rgba(0, 0, 0, 0.5)",
                            "stroke-width" to 0.01
                        )
                    }
                }
            }
        }

        val element = definition.toElement()
        val children = element.children.asList().filterIsInstance<SVGElement>()
        for (i in children) {
            lodParent.append(i)
        }
    }
}

